module.exports = "/_next/static/images/5777a5ec1acaf873420f105ffc21617d-nubank-outdoor-xs@1x.jpg.webp";